var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "closebtn-broker-app pointer",
    on: {
      "click": function click($event) {
        return _vm.restoreApplication();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon extrasmall white filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1c_icons8-reset.svg",
      "loading": "lazy"
    }
  })]), _c('div', {
    staticClass: "hypoteka-top grey w-inline-block"
  }, [_vm.object.coapplicant ? _c('div', {
    staticClass: "position-relative"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f48_two%20applicants%20icon.png",
      "loading": "lazy",
      "alt": ""
    }
  })]) : _c('div', [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "MGleft10px bold blc-color"
  }, [_vm.object.applicant ? _c('user-manager-handler', {
    attrs: {
      "class-cst": 'blc-color',
      "rules": ['priority'],
      "client-info": _vm.object.applicant,
      "client": ""
    }
  }) : _vm._e(), _vm.object.coapplicant ? _c('div', {
    staticClass: "co-applicant-name pop-500"
  }, [_vm._v(" & "), _vm.object.coapplicant.first_name ? _c('span', [_vm._v(" " + _vm._s(_vm.object.coapplicant.first_name) + " " + _vm._s(_vm.object.coapplicant.last_name) + " ")]) : _c('span', [_vm._v(" ID " + _vm._s(_vm.object.coapplicant.id) + " ")])]) : _vm._e()], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }